import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  getCapstoneDetails,
  getCapstoneID,
  getLevelDetails,
  showProgress,
} from '../../../redux/actions/DealershipActions';
import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';

const useAiExercise = () => {
  const dispatch = useDispatch();

  const [error, setError] = useState(null);
  const [exercises, setExercises] = useState([]);

  const fetchAiExercises = useCallback(
    async (journeyId) => {
      dispatch(showProgress(true));
      try {
        const response = await service.get(apiEndpoints.JOURNEY_AI_ROLEPLAY_LIST.replace('ID', journeyId));
        setExercises(response);
      } catch (err) {
        setError(err);
        dispatch(showProgress(false));
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch],
  );
  const fetchDetails = useCallback(
    async (levelId) => {
      dispatch(showProgress(true));

      try {
        const p1 = service.get(apiEndpoints.JOURNEY_GUIDES_LIST.replace('ID', levelId), '');
        const p2 = service.get(apiEndpoints.JOURNEY_CAPSTONE_DETAILS.replace('LEVEL_ID', levelId), '');
        const responses = await Promise.all([p1, p2]);
        dispatch(getLevelDetails('levelDetails', responses[0]));
        dispatch(getCapstoneDetails('fetch', responses[1]));
        dispatch(getCapstoneID(responses[1]?.id));
      } catch (err) {
        setError(err);
        dispatch(showProgress(false));
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch],
  );
  return {
    exercises,
    fetchAiExercises,
    fetchDetails,
    error,
  };
};

export default useAiExercise;
